@let isBusy = statusType() === StatusType.BUSY;

<div class="dropdown">
  <button class="btn border-0 position-relative p-2" data-bs-auto-close="outside" data-bs-toggle="dropdown" title="Shopping Cart" type="button" aria-label="Shopping Card" aria-expanded="false" i18n-aria-label i18n-title>
    <fa-icon class="text-secondary" [icon]="iconCart" [fixedWidth]="true" [size]="'lg'" aria-hidden="true" />
    @if (cart()?.items!.length; as itemCount) {
    <span class="badge text-bg-primary text-secondary rounded-pill position-absolute end-0 top-0" style="font-size: 0.75em;">{{ itemCount }}</span>
    }
  </button>

  <div class="dropdown-menu dropdown-menu-end">
    <h6 class="dropdown-header ls-3 text-uppercase">
      <strong i18n>Bağış Sepetim</strong>
    </h6>
    <hr class="dropdown-divider">

    @if(cart(); as cart) {
    <ul class="dropdown-list">
      <!-- Items -->
      @for (item of cart.items; track item; let i = $index) {
      <li>
        <div class="dropdown-item">
          <div class="d-flex align-items-start gap-2 position-relative">
            <img [src]="item.summary.imageUrl" style="height: 2.5rem; width: 2.5rem;" title="Product Image" [attr.aria-label]="item.summary.name + ' Image'" i18n-title />

            <div class="d-flex flex-column flex-grow-1">
              <div class="row align-items-center justify-content-between">
                <div class="col" style="max-width: 10rem; min-width: 0;">
                  <h6 class="text-truncate name mb-1" style="font-size: 1.25em;">{{ item.summary.name }}</h6>
                </div>

                <div class="col-auto">
                  <button class="btn btn-close btn-sm p-0" (click)="onRemoveItem(item)" [disabled]="isBusy" style="z-index: 2;" title="Remove Item" type="button" aria-label="Remove Item" i18n-title i18n-aria-label>

                  </button>
                </div>
              </div>

              <div class="row align-items-center justify-content-between">
                <div class="col">
                  <p class="text-truncate mb-0" style="font-size: 1em;">{{ item.price | currency }}</p>
                </div>

                <div class="col-auto">
                  <p class="mb-0" style="font-size: 1em;">x{{ item.quantity }}</p>
                </div>
              </div>
            </div>

            <!-- <a class="stretched-link" data-bs-dismiss="dropdown" [routerLink]="item.summary.imageUrl" [attr.aria-label]="item.summary.name" [title]="item.summary.name"></a> -->
          </div>
        </div>
      </li>
      }
      <!-- Empty Message -->
      @empty {
      <li>
        <span class="dropdown-item text-center" i18n>Sepette henüz bir bağış yok...</span>
      </li>
      }
    </ul>

    <!-- Total -->
    @if(cart.total > 0) {
    <hr class="dropdown-divider">
    <h6 class="dropdown-footer d-flex justify-content-between">
      <span i18n>Toplam</span>
      <span>{{ cart.total | currency }}</span>
    </h6>
    }
    }
    <!-- Loading -->
    @else {
    <div class="text-center text-primary p-3">
      <div class="spinner-border" role="status">
        <span class="visually-hidden" i18n>Yükleniyor...</span>
      </div>
    </div>
    }

    <hr class="dropdown-divider">
    <a class="dropdown-action btn btn-primary btn-sm text-light w-100" [ngClass]="{ disabled: !cart() }" [routerLink]="['/donate/checkout']" i18n>
      <strong>Sepete Git</strong>
    </a>
  </div>
</div>